/**
 * Device-wide settings shared by every user on this browser. Location-scoped and
 * user-scoped values belong in their own objects (see user-preferences.util.ts).
 */
export const COMMON_SETTINGS_STORAGE_KEY = 'way_common_settings';

/** Checkout request id this tablet claimed each order with, keyed by order id (CWS-1987). */
export type CheckoutRequestIds = Record<string, { requestId: string; at: number }>;

export interface CommonSettings {
  /** Last Stripe Terminal reader (S700) used for POS checkout. */
  terminalReaderId?: string;
  /** Recent payment claims, so reopening an order or reloading the app keeps this tablet's claim. */
  checkoutRequestIds?: CheckoutRequestIds;
}

export function readCommonSettings(): CommonSettings {
  try {
    const parsed = JSON.parse(localStorage.getItem(COMMON_SETTINGS_STORAGE_KEY) || '{}');
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

export function updateCommonSettings(patch: Partial<CommonSettings>): void {
  try {
    localStorage.setItem(
      COMMON_SETTINGS_STORAGE_KEY,
      JSON.stringify({ ...readCommonSettings(), ...patch })
    );
  } catch {
    // Storage full or blocked: settings just won't persist.
  }
}
